import { createFileRoute } from '@tanstack/react-router'

import { AccessPage } from '@/pages/admin/access/access-page'

export const Route = createFileRoute('/_private/admin/access')({
  component: AccessPage,
})
